var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLineCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M4.999 5H55v50H4.999V5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M30 5c13.806 0 25 11.193 25 25S43.806 55 30 55C16.193 55 4.999 43.807 4.999 30S16.193 5 30 5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLineCircleIcon);
export default __webpack_public_path__ + "static/media/white-line-circle-icon.81dd9e3d9ccb252e4c2ea20b27f1b633.svg";
export { ForwardRef as ReactComponent };